export default {
    methods: {
        resetSearchForm(){
          this.query = this.$options.data().query
          this.handleSearch();
        },
        handlePageChange (pageNum) {
          this.page.page = pageNum
          this.handleSearch();
        },
        handlePageSortChange({column,prop,order}){
          if(order=='normal'){
              this.page.sort = this.$options.data().page.sort;
          }else{
            this.page.sort = `${column.column}_${order}`
          }
          this.handleSearch()
        },
        handleBatchOperate(){
          let records = this.$refs.webSiteTable.getSelection()
          if (records.length == 0) {
            this.$Message.warning(this.$t('errorText'))
            return;
          }
          this[this.batchOperate.action](records)
        }
    },
    mounted(){
        this.handleSearch();
    }
}
